// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-section[data-v-bb013292]{background:#fdefef;margin:0 auto 16px;padding:16px;max-width:736px;border-radius:8px}.alert-section h3[data-v-bb013292]{color:#dc5353;font-weight:700;font-size:1.2rem;margin-bottom:1rem}.alert-section p[data-v-bb013292]{text-align:left}.alert-section p[data-v-bb013292]:last-child{margin:0}", ""]);
// Exports
module.exports = exports;
